import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tab from "@mui/material/Tab";
import React from "react";
import { useAlert } from "../../../alerts/AlertContext";
import UserAddress from "./UserAddress";
import UserGroups from "./UserGroups";
import UserInfoRoles from "./UserInfoRoles";

function UserInfoDialog({ editUserId, selectedUserName }) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("1");
  const showAlert = useAlert();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <React.Fragment>
      <AccountCircleIcon
        style={{ cursor: "pointer" }}
        onClick={handleClickOpen}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: 600, // fixed width
            height: 450, // fixed height
            maxWidth: "100%", // optional for responsiveness
            maxHeight: "100%", // optional to prevent overflow
          },
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();

            // saveUser();
            handleClose();
          },
        }}
      >
        <DialogTitle>{selectedUserName}</DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{ "& .MuiTextField-root": { m: 1 } }}
            noValidate
            autoComplete="off"
          >
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleChange} aria-label="Org's">
                  <Tab label="Contact Info" value="1" />
                  <Tab label="Groups" value="2" />
                  <Tab label="Roles" value="3" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <UserAddress
                  editUserId={editUserId}
                  selectedUserName={selectedUserName}
                />
              </TabPanel>
              <TabPanel value="2">
                <UserGroups
                  editUserId={editUserId}
                  selectedUserName={selectedUserName}
                />
              </TabPanel>
              <TabPanel value="3">
                <UserInfoRoles
                  editUserId={editUserId}
                  selectedUserName={selectedUserName}
                />
              </TabPanel>
            </TabContext>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
export default UserInfoDialog;
